import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityCrudService } from '@data/entity-crud.service';
import { CustomBranch } from '@data/custom-branch/custom-branch.model';

@Injectable({
  providedIn: 'root',
})
export class CustomBranchService extends EntityCrudService<CustomBranch, CustomBranch> {
  constructor() {
    const http = inject(HttpClient);

    super('custom-branches', http);
  }
}
